var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImportBtn = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 24,
  height: 24,
  rx: 4,
  fill: "#6B5CE8"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.8172 12.0578C16.8753 12.1159 16.9214 12.1848 16.9529 12.2607C16.9843 12.3365 17.0005 12.4179 17.0005 12.5C17.0005 12.5821 16.9843 12.6635 16.9529 12.7393C16.9214 12.8152 16.8753 12.8841 16.8172 12.9422L11.1922 18.5672C11.1341 18.6253 11.0652 18.6713 10.9893 18.7027C10.9134 18.7342 10.8321 18.7503 10.75 18.7503C10.6679 18.7503 10.5866 18.7342 10.5107 18.7027C10.4348 18.6713 10.3659 18.6253 10.3078 18.5672C10.2497 18.5091 10.2037 18.4402 10.1723 18.3643C10.1408 18.2884 10.1247 18.2071 10.1247 18.125C10.1247 18.0429 10.1408 17.9616 10.1723 17.8857C10.2037 17.8098 10.2497 17.7409 10.3078 17.6828L14.8664 13.125H4.5C4.33424 13.125 4.17527 13.0592 4.05806 12.9419C3.94085 12.8247 3.875 12.6658 3.875 12.5C3.875 12.3342 3.94085 12.1753 4.05806 12.0581C4.17527 11.9408 4.33424 11.875 4.5 11.875H14.8664L10.3078 7.31719C10.1905 7.19991 10.1247 7.04085 10.1247 6.875C10.1247 6.70915 10.1905 6.55009 10.3078 6.43281C10.4251 6.31554 10.5841 6.24965 10.75 6.24965C10.9159 6.24965 11.0749 6.31554 11.1922 6.43281L16.8172 12.0578ZM18.875 5C18.7092 5 18.5503 5.06585 18.4331 5.18306C18.3158 5.30027 18.25 5.45924 18.25 5.625V19.375C18.25 19.5408 18.3158 19.6997 18.4331 19.8169C18.5503 19.9342 18.7092 20 18.875 20C19.0408 20 19.1997 19.9342 19.3169 19.8169C19.4342 19.6997 19.5 19.5408 19.5 19.375V5.625C19.5 5.45924 19.4342 5.30027 19.3169 5.18306C19.1997 5.06585 19.0408 5 18.875 5Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgImportBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/import_btn.7b38058cb2dce2b87986a3902bbca941.svg";